import GridViewTableController from './grid-view-table.controller';
import { GridViewTableProps } from './grid-view-table.model';

const GridViewTable = (props: GridViewTableProps) => {
  return <GridViewTableController {...props} />;
};

export default GridViewTable;
